import * as _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { allFetchersMap } from '../../../../../shared/fetchers';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import { selectOptionFactory } from '../../../../utils';
import type { SelectOption } from '../../../../types';

// include both fossa-specific and third-party package managers as dropdown options
const PACKAGE_MANAGER_DROPDOWN_OPTIONS: Array<SelectOption<string>> = _.sortBy(
  Object.entries(allFetchersMap).map(([value, label]) => selectOptionFactory(value, label)),
  elem => elem.label,
);

/**
 * Fetches the list of relevant package managers whenever the current revision changes.
 */
const usePackageManagers = (): {
  arePackageManagersLoading: boolean;
  packageManagers: Array<SelectOption<string>>;
} => {
  const dispatch = useDispatch();

  const arePackageManagersLoading = useSelector(DependenciesV2Store.selectors.getAreDependenciesLoading);
  const packageManagers = useSelector(DependenciesV2Store.selectors.getPackageManagers);

  // fetch updated package managers whenever the current scope changes
  const scope = useSelector(DependenciesV2Store.selectors.getScope);
  useEffect(() => {
    if (!scope) {
      return;
    }

    dispatch(DependenciesV2Store.actions.fetchPackageManagersAction(scope));
  }, [dispatch, scope]);

  // filter dropdown options down to just the available package managers
  const options = PACKAGE_MANAGER_DROPDOWN_OPTIONS.filter((option) => packageManagers?.includes(option.value));

  return {
    arePackageManagersLoading,
    packageManagers: options,
  };
};

export default usePackageManagers;
